<template>
  <div class="plans">
    <h1>我的成绩</h1>
    <div class="content">
      <div class="allsocre">
        <p class="scoreinfo">我的总成绩</p>
         <div class="scorename">89</div>
        <p class="scoreinfo">成绩说明：网上学习 : 课件学习(12%) + 阶段测验(12%) + 简答练习(8%) + 综合作业(8%)</p>
      </div>
          <ul>
            <li class="liinfo">
            <div class="li-top">规则条款一</div>
            <table  class="table table-bordered">
              <tr>
                <td class="infobg" width="10%" >学期</td>
                <td class="infobg" width="25%" >课程</td>
                <td class="infobg" width="15%">成绩</td>
                <td class="infobg" width="10%">学期</td>
                <td  class="infobg" width="25%">课程</td>
                <td class="infobg" width="15%">成绩</td>
              </tr>
              <tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores"><router-link to="/scoredetail">78</router-link></td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>
              <tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr><tr>
              <td>1</td>
              <td>法理学</td>
              <td class="scores">78</td>
              <td>1</td>
              <td>民法学</td>
              <td class="scores">77</td>
            </tr>
              <tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>
              <tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>
              <tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>

            </table>

          </li>
            <li class="liinfo">
              <div class="li-top">规则条款一</div>
              <table  class="table table-bordered">
                <tr>
                  <td class="infobg" width="10%" >学期</td>
                  <td class="infobg" width="25%" >课程</td>
                  <td class="infobg" width="15%">成绩</td>
                  <td class="infobg" width="10%">学期</td>
                  <td  class="infobg" width="25%">课程</td>
                  <td class="infobg" width="15%">成绩</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores"><router-link to="/scoredetail">78</router-link></td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr><tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>

              </table>

            </li>
            <li class="liinfo">
              <div class="li-top">规则条款一</div>
              <table  class="table table-bordered">
                <tr>
                  <td class="infobg" width="10%" >学期</td>
                  <td class="infobg" width="25%" >课程</td>
                  <td class="infobg" width="15%">成绩</td>
                  <td class="infobg" width="10%">学期</td>
                  <td  class="infobg" width="25%">课程</td>
                  <td class="infobg" width="15%">成绩</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores"><router-link to="/scoredetail">78</router-link></td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr><tr>
                <td>1</td>
                <td>法理学</td>
                <td class="scores">78</td>
                <td>1</td>
                <td>民法学</td>
                <td class="scores">77</td>
              </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>法理学</td>
                  <td class="scores">78</td>
                  <td>1</td>
                  <td>民法学</td>
                  <td class="scores">77</td>
                </tr>

              </table>

            </li>
          </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanList',
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .plans{
    margin-bottom:30px;
    h1{
      font-size:16px;
      font-weight:bold;
      margin-bottom:20px;
    }
    .content{
      background:#fff;
      padding:28px;
      .liinfo{

      }
      .li-top{
        font-size:16px;
        font-weight:bold;
        color:$bgColor;
        margin-bottom:20px;
      }
      .table td{
        background:#fff;
        text-align:center;
        &.infobg{
          background:$bgColor;
          font-weight:bold;
          color:#fff;
        }
      }
      .scorename{
        font-size:34px;
        text-align:center;
        line-height:56px;
        background:url("../../../assets/images/hg.png") no-repeat center 10px;
      }
      .allsocre{
        background:$bgcontent;
        padding:28px;
        margin-bottom:30px;
      }
      .scoreinfo{
         text-align:center;
          color:#999;
          margin-top:15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/scoredetail/components/PlanList.vue